<template>
  <div class="sy-paas-single-choices">
    <component :is="componentName" v-on="$listeners" v-bind="{...$props, options: newOptions}" v-model="value"/>
  </div>
</template>

<style lang="scss" scoped>
  .sy-paas-single-choices {
    .redio-single-choice-small {
      ::v-deep .el-radio{
        height: 32px;
        line-height: 32px;
      }
    }
    ::v-deep .el-select {
      width: 100%;
    }
    .redio-single-choice{
      ::v-deep .el-radio{
        height: 32px;
        line-height: 32px;
        max-width: 290px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
</style>

<script>
  import selectSingleChoice from './components/select-single-choice.vue'
  import radioSingleChoice from './components/radio-single-choice.vue'
  import readSingleChoice from './components/read-single-choice.vue'
  import {singleChoiceProps} from './index.js'

  export default {
    name: 'single-choice',
    model: {
      event: '_change',
      prop: 'value'
    },
    props: singleChoiceProps,
    computed: {
      componentName () {
        if (this.isPureText) {
          return 'readSingleChoice'
        }
        if (this.uiComponent === 1) {
          return 'selectSingleChoice'
        }
        return 'radioSingleChoice'
      },
      newOptions () {
        return this.options.filter(
          item => (item.state && item.choiceKey === this.value) || !item.state
        )
      }
    },
    components: {
      selectSingleChoice,
      radioSingleChoice,
      readSingleChoice
    },
    watch: {
      value (val) {
        this.$emit('_change', val)
      }
    }
  }
</script>
